import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { get, isNil } from 'lodash';
import { Grid, Tooltip } from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';
import CircularProgress from '@material-ui/core/CircularProgress';

import { useSelector } from 'react-redux';
import VisibilityIcon from '@material-ui/icons/Visibility';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import messages from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/messages';
import { translate } from 'containers/services/translate';
import upload from 'images/upload.svg';
import {
  uploadClick as uploadDocumentOnClick,
  fileSelectHandler,
} from 'containers/LawyerLegalProceedingsPage/judgementAdd/utils';
import { IUploadedDocument } from 'containers/LawyerLegalProceedingsPage/typings';
import { DOCUMENT } from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/constants';
import { openDocument } from 'containers/UploadDocuments/utils';
import Document from 'components/Document';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import { makeSelectDocumentumId } from 'containers/UploadDocuments/selectors';
import { CorporealDocument } from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/typings';
import { useTesseract } from 'hooks/useTesseract';
import { useState } from 'react';
import { COLORS } from 'constants/design';
export interface UploadDocumentProps {
  intl: IntlShape;
  document: CorporealDocument;
  setDocument: Function;
  resetUploadedDocument?: Function;
  uploadDocument: Function;
  uploadedDocument: IUploadedDocument;
  index: number;
  docType: string;
  docId?: string;
  setDocumentId?: Function;
  shouldDisplay?: boolean;
  title?: string;
  deleteDoc?: Function;
  shouldNotDisplayUploadTitle?: boolean;
  shouldNotCallReset?: boolean;
  shouldExtractTextFromDoc?: boolean;
}

export const UploadDocument: React.FC<UploadDocumentProps> = (
  props,
): JSX.Element => {
  const fileRef: React.RefObject<HTMLInputElement> = React.createRef();
  const documentumId = useSelector(makeSelectDocumentumId());
  const [extractedText, setExtractedText] = useState(null);
  const { recognize, loading } = useTesseract('fra', setExtractedText);

  React.useEffect(() => {
    const documentUrl = get(props, ['uploadedDocument', 'response']);
    if (documentUrl) {
      const name = DOCUMENT + ' ' + (props.index + 1);
      props.setDocument({
        ...props.document,
        url: documentUrl,
        documentumId: documentumId,
        name,
        isIndexed: !isNil(documentumId),
        type: props.docType,
      });
      !props.shouldNotCallReset &&
        props.resetUploadedDocument &&
        props.resetUploadedDocument();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.uploadedDocument]);
  const shouldDisplayDocument = () => !!props.document?.url;

  const { name, url, type } = props.document;
  return (
    <section className="upload-document">
      {!shouldDisplayDocument() && (
        <>
          {!props.shouldNotDisplayUploadTitle && (
            <div className="upload-doc-title">
              {props.shouldDisplay &&
                translate(messages.uploadDocumentTitle, props)}
            </div>
          )}
          <PrimaryButton
            className="upload-document-button"
            onClick={uploadDocumentOnClick(fileRef)}
            lefticon={<img className="cloud-icon" src={upload} alt="" />}
            title={
              props.title
                ? props.title
                : translate(messages.uploadDocumentButtonTitle, props)
            }
          />
        </>
      )}
      {shouldDisplayDocument() && (
        //to-update
        <Grid container direction="row">
          <Grid item xs>
            <Document
              name={name}
              type={type}
              icon={
                <div style={{ display: 'flex' }}>
                  <VisibilityIcon
                    className="consult"
                    onClick={openDocument(url)}
                  />
                  <DeleteOutlineIcon
                    data-testid="delete-icon"
                    style={{ marginLeft: '12px' }}
                    onClick={() => {
                      if (props.deleteDoc) props.deleteDoc();
                    }}
                  />
                  {props.shouldExtractTextFromDoc && loading ? (
                    <CircularProgress className="loader" size={20} />
                  ) : (
                    props.shouldExtractTextFromDoc && (
                      <Tooltip
                        title={`Numero de facture :${get(
                          extractedText,
                          'invoiceFields.invoiceNumber',
                          '',
                        )} , Date de facture: ${get(
                          extractedText,
                          'invoiceFields.invoiceDate',
                          '',
                        )}`}
                      >
                        <InfoIcon
                          style={{
                            height: '20px',
                            width: '20px',
                            marginLeft: '12px',
                            marginTop: '2px',
                            cursor: 'pointer',
                            color: COLORS.GREY,
                          }}
                        />
                      </Tooltip>
                    )
                  )}
                </div>
              }
            />
          </Grid>
        </Grid>
      )}
      <input
        id="selectImage"
        type="file"
        onChange={fileSelectHandler(props.uploadDocument, {
          intl: props.intl,
          docId: props.docId as string,
          setDocumentId: props.setDocumentId,
          setText: setExtractedText,
          recognize: props.shouldExtractTextFromDoc ? recognize : undefined,
        })}
        ref={fileRef}
        hidden
      />
    </section>
  );
};

export default injectIntl(UploadDocument);

UploadDocument.defaultProps = {
  shouldDisplay: true,
};
